import { Comment as e, Fragment as t, Teleport as n, camelize as r, cloneVNode as i, computed as a, createBlock as o, createCommentVNode as s, createVNode as c, defineComponent as l, effectScope as u, getCurrentInstance as d, guardReactiveProps as f, h as p, inject as m, mergeProps as h, nextTick as g, normalizeProps as _, normalizeStyle as ee, onMounted as v, onUnmounted as te, onUpdated as y, openBlock as b, provide as x, reactive as S, ref as C, renderSlot as w, toHandlerKey as T, toRefs as ne, toValue as E, triggerRef as D, unref as O, useId as re, watch as k, watchEffect as A, withCtx as j } from "vue";
import { defaultWindow as M, isClient as N, isIOS as P, onKeyStroke as F, tryOnBeforeUnmount as ie, unrefElement as I, useEventListener as L, useMounted as ae } from "@vueuse/core";
import { attempt as R, isNil as z } from "es-toolkit";
import { hideOthers as B } from "aria-hidden";
//#region src/composables/useDismissableLayer/context.ts
var V = S({
	layersRoot: /* @__PURE__ */ new Set(),
	layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
	originalBodyPointerEvents: void 0,
	branches: /* @__PURE__ */ new Set()
}), oe = () => {
	let e = C(/* @__PURE__ */ new Map()), t = C(), n = a(() => {
		for (let t of e.value.values()) if (t) return !0;
		return !1;
	}), r = null, i = () => {
		document.body.style.paddingRight = "", document.body.style.marginRight = "", V.layersWithOutsidePointerEventsDisabled.size === 0 && (document.body.style.pointerEvents = ""), document.documentElement.style.removeProperty("--scrollbar-width"), document.body.style.overflow = t.value ?? "", P && r?.(), t.value = void 0;
	};
	return k(n, (e, a) => {
		if (!N) return;
		if (!e) {
			a && i();
			return;
		}
		/* c8 ignore next -- every unlock clears this, so it is always undefined when locking. */
		t.value === void 0 && (t.value = document.body.style.overflow);
		let o = window.innerWidth - document.documentElement.clientWidth, s = {
			padding: o,
			margin: 0
		};
		o > 0 && 
		/* c8 ignore start -- config is a local literal, so both values are always numbers. */
		(document.body.style.paddingRight = typeof s.padding == "number" ? `${s.padding}px` : String(s.padding), document.body.style.marginRight = typeof s.margin == "number" ? `${s.margin}px` : String(s.margin), document.documentElement.style.setProperty("--scrollbar-width", `${o}px`), document.body.style.overflow = "hidden"), P && (r = L(document, "touchmove", (e) => H(e), { passive: !1 })), g(() => {
			n.value && (document.body.style.pointerEvents = "none", document.body.style.overflow = "hidden");
		});
	}, {
		immediate: !0,
		flush: "sync"
	}), e;
}, se, ce = () => se ??= u(!0).run(oe), le = (e) => {
	let t = Math.random().toString(36).substring(2, 7), n = ce();
	n.value.set(t, e ?? !1);
	let r = a({
		get: () => n.value.get(t) ?? !1,
		set: (e) => n.value.set(t, e)
	});
	return ie(() => {
		n.value.delete(t);
	}), r;
}, ue = (e) => {
	let t = window.getComputedStyle(e);
	if (t.overflowX === "scroll" || t.overflowY === "scroll" || t.overflowX === "auto" && e.clientWidth < e.scrollWidth || t.overflowY === "auto" && e.clientHeight < e.scrollHeight) return !0;
	{
		let t = e.parentNode;
		return !(t instanceof Element) || t.tagName === "BODY" ? !1 : ue(t);
	}
}, H = (e) => {
	/* c8 ignore next -- the listener always hands over an event; window.event is a legacy fallback. */
	let t = e || window.event, n = t.target;
	return n instanceof Element && ue(n) ? !1 : t.touches.length > 1 || (t.preventDefault && t.cancelable && t.preventDefault(), !1);
}, U = () => {
	let e = document.activeElement;
	if (e == null) return null;
	for (; e != null && e.shadowRoot != null && e.shadowRoot.activeElement != null;) e = e.shadowRoot.activeElement;
	return e;
}, de = (e, t, n) => {
	let { originalEvent: r } = n, i = r.target, a = new CustomEvent(e, {
		bubbles: !1,
		cancelable: !0,
		detail: n
	});
	i && (t && i.addEventListener(e, t, { once: !0 }), i.dispatchEvent(a));
}, fe = "focusScope.autoFocusOnMount", W = "focusScope.autoFocusOnUnmount", G = {
	bubbles: !1,
	cancelable: !0
}, pe = (e, { select: t = !1 } = {}) => {
	let n = U();
	for (let r of e) if (q(r, { select: t }), U() !== n) return !0;
}, me = (e) => {
	let t = K(e);
	return [he(t, e), he(t.reverse(), e)];
}, K = (e) => {
	let t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, { acceptNode: (e) => {
		let t = e, n = t.tagName === "INPUT" && t.type === "hidden";
		return t.disabled || t.hidden || n ? NodeFilter.FILTER_SKIP : t.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
	} });
	for (; n.nextNode();) t.push(n.currentNode);
	return t;
}, he = (e, t) => {
	for (let n of e) if (!ge(n, { upTo: t })) return n;
}, ge = (e, { upTo: t }) => {
	if (getComputedStyle(e).visibility === "hidden") return !0;
	for (; e;) {
		if (t !== void 0 && e === t) return !1;
		if (getComputedStyle(e).display === "none") return !0;
		e = e.parentElement;
	}
	return !1;
}, _e = (e) => e instanceof HTMLInputElement && "select" in e, q = (e, { select: t = !1 } = {}) => {
	if (e && e.focus) {
		let n = U();
		e.focus({ preventScroll: !0 }), e !== n && _e(e) && t && e.select();
	}
}, J = {
	swipeMovementX: "--drawer-swipe-movement-x",
	swipeMovementY: "--drawer-swipe-movement-y"
}, Y = (e, t, n) => {
	switch (e) {
		case "up": return -n;
		case "down": return n;
		case "left": return -t;
		case "right": return t;
		default: return 0;
	}
}, ve = /matrix(?:3d)?\(([^)]+)\)/, ye = (e) => {
	let t = window.getComputedStyle(e).transform, n = 0, r = 0, i = 1;
	if (t && t !== "none") {
		let e = t.match(ve);
		if (e) {
			let t = e[1].split(", ").map(Number);
			t.length === 6 ? (n = t[4], r = t[5], i = Math.sqrt(t[0] * t[0] + t[1] * t[1])) : t.length === 16 && (n = t[12], r = t[13], i = t[0]);
		}
	}
	return {
		x: n,
		y: r,
		scale: i
	};
}, be = !1, xe = () => {
	if (!(be || typeof CSS > "u" || !CSS.registerProperty)) {
		for (let e of [J.swipeMovementX, J.swipeMovementY]) R(() => CSS.registerProperty({
			name: e,
			syntax: "<length>",
			inherits: !1,
			initialValue: "0px"
		}));
		be = !0;
	}
}, Se = "dismissableLayer.pointerDownOutside", Ce = "dismissableLayer.focusOutside", we = (e, t) => {
	if (!(t instanceof Element)) return !1;
	let n = t.closest("[data-dismissable-layer]"), r = e.dataset.dismissableLayer === "" ? e : e.querySelector("[data-dismissable-layer]"), i = Array.from(e.ownerDocument.querySelectorAll("[data-dismissable-layer]"));
	return !!(n && (r === n || i.indexOf(r) < i.indexOf(n)));
}, Te = (e, t, n = !0) => {
	let r = t?.value?.ownerDocument ?? globalThis?.document, i = C(!1), a = C(() => {});
	return A((o) => {
		if (!N || !E(n)) return;
		let s = (n) => {
			let o = n.target;
			if (!(!t?.value || !o)) {
				if (we(t.value, o)) {
					i.value = !1;
					return;
				}
				if (n.target && !i.value) {
					let t = { originalEvent: n }, i = () => {
						de(Se, e, t);
					};
					n.pointerType === "touch" ? (r.removeEventListener("click", a.value), a.value = i, r.addEventListener("click", a.value, { once: !0 })) : i();
				} else r.removeEventListener("click", a.value);
				i.value = !1;
			}
		}, c = window.setTimeout(() => {
			r.addEventListener("pointerdown", s);
		}, 0);
		o(() => {
			window.clearTimeout(c), r.removeEventListener("pointerdown", s), r.removeEventListener("click", a.value);
		});
	}), { onPointerDownCapture: () => {
		E(n) && (i.value = !0);
	} };
}, Ee = (e, t, n = !0) => {
	let r = t?.value?.ownerDocument ?? globalThis?.document, i = C(!1);
	return A((a) => {
		if (!N || !E(n)) return;
		let o = async (n) => {
			if (!t?.value) return;
			await g(), await g();
			let r = n.target;
			!t.value || !r || we(t.value, r) || n.target && !i.value && de(Ce, e, { originalEvent: n });
		}, s = (e) => void o(e);
		r.addEventListener("focusin", s), a(() => r.removeEventListener("focusin", s));
	}), {
		onFocusCapture: () => {
			E(n) && (i.value = !0);
		},
		onBlurCapture: () => {
			E(n) && (i.value = !1);
		}
	};
}, De = (e) => {
	let t = d(), n = t?.type.emits, i = {};
	return n?.length || console.warn(`No emitted event found. Please check component: ${t?.type.__name}`), n?.forEach((t) => {
		i[T(r(t))] = ((...n) => void e(t, ...n));
	}), i;
}, X = () => {
	let e = d(), t = C(), n = a(() => r());
	y(() => {
		n.value !== r() && D(t);
	});
	let r = () => {
		let e = t.value && "$el" in t.value ? t.value.$el : null;
		return e && ["#text", "#comment"].includes(e.nodeName) ? e.nextElementSibling : I(t);
	}, i = Object.assign({}, e.exposed), o = {};
	for (let t in e.props) Object.defineProperty(o, t, {
		enumerable: !0,
		configurable: !0,
		get: () => e.props[t]
	});
	if (Object.keys(i).length > 0) for (let e in i) Object.defineProperty(o, e, {
		enumerable: !0,
		configurable: !0,
		get: () => i[e]
	});
	return Object.defineProperty(o, "$el", {
		enumerable: !0,
		configurable: !0,
		get: () => e.vnode.el
	}), e.exposed = o, {
		forwardRef: (n) => {
			if (t.value = n, n && (Object.defineProperty(o, "$el", {
				enumerable: !0,
				configurable: !0,
				get: () => n instanceof Element ? n : n.$el
			}), !(n instanceof Element) && !Object.hasOwn(n, "$el"))) {
				let t = n.$.exposed, r = Object.assign({}, o);
				for (let e in t) Object.defineProperty(r, e, {
					enumerable: !0,
					configurable: !0,
					get: () => t[e]
				});
				e.exposed = r;
			}
		},
		currentRef: t,
		currentElement: n
	};
}, Oe = (e) => {
	let t;
	k(() => I(e), (e) => {
		let n = !1;
		try {
			n = !!e?.closest("[popover]:not(:popover-open)");
		} catch {}
		e && !n ? t = B(e) : t && t();
	}), te(() => {
		t && t();
	});
}, ke = 0, Ae = (e, t = "mp") => {
	if (e) return e;
	/* c8 ignore next -- Vue returns an empty string, not null, so the counter is never reached. */
	let n = re() ?? `${++ke}`;
	return t ? `${t}-${n}` : n;
}, je = (e, t) => {
	let n = C(e), r = (e) => t[n.value][e] ?? n.value;
	return {
		state: n,
		dispatch: (e) => {
			n.value = r(e);
		}
	};
}, Me = (e, t) => {
	let n = C({}), r = C("none"), i = C(e), o = e.value ? "mounted" : "unmounted", s, c = t.value?.ownerDocument.defaultView ?? M, { state: l, dispatch: u } = je(o, {
		mounted: {
			UNMOUNT: "unmounted",
			ANIMATION_OUT: "unmountSuspended"
		},
		unmountSuspended: {
			MOUNT: "mounted",
			ANIMATION_END: "unmounted"
		},
		unmounted: { MOUNT: "mounted" }
	}), d = (e) => {
		if (N) {
			let n = new CustomEvent(e, {
				bubbles: !1,
				cancelable: !1
			});
			t.value?.dispatchEvent(n);
		}
	};
	k(e, async (e, i) => {
		let a = i !== e;
		if (await g(), a) {
			let a = r.value, o = Ne(t.value);
			e ? (u("MOUNT"), d("enter"), o === "none" && d("after-enter")) : o === "none" || o === "undefined" || n.value?.display === "none" ? (u("UNMOUNT"), d("leave"), d("after-leave")) : i && a !== o ? (u("ANIMATION_OUT"), d("leave")) : (u("UNMOUNT"), d("after-leave"));
		}
	}, { immediate: !0 });
	let f = (e) => {
		if (e.target !== t.value) return;
		let n = Ne(t.value), r = n.includes(CSS.escape(e.animationName)), a = l.value === "mounted" ? "enter" : "leave";
		if (r && (d(`after-${a}`), u("ANIMATION_END"), !i.value)) {
			let e = t.value.style.animationFillMode;
			t.value.style.animationFillMode = "forwards", s = c?.setTimeout(() => {
				t.value?.style.animationFillMode === "forwards" && (t.value.style.animationFillMode = e);
			});
		}
		n === "none" && u("ANIMATION_END");
	}, p = (e) => {
		e.target === t.value && (r.value = Ne(t.value));
	}, m = k(t, (e, t) => {
		e ? (n.value = getComputedStyle(e), e.addEventListener("animationstart", p), e.addEventListener("animationcancel", f), e.addEventListener("animationend", f)) : (u("ANIMATION_END"), s !== void 0 && c?.clearTimeout(s), t?.removeEventListener("animationstart", p), t?.removeEventListener("animationcancel", f), t?.removeEventListener("animationend", f));
	}, { immediate: !0 }), h = k(l, () => {
		let e = Ne(t.value);
		r.value = l.value === "mounted" ? e : "none";
	});
	return te(() => {
		m(), h(), t.value && (t.value.removeEventListener("animationstart", p), t.value.removeEventListener("animationcancel", f), t.value.removeEventListener("animationend", f)), s !== void 0 && c?.clearTimeout(s);
	}), { isPresent: a(() => ["mounted", "unmountSuspended"].includes(l.value)) };
}, Ne = (e) => e && getComputedStyle(e).animationName || "none", Pe = 40, Fe = 10, Ie = 1, Le = 6, Re = 2, ze = 16, Be = 80, Ve = "button,a,input,select,textarea,label,[role=\"button\"]", He = (e, t) => {
	if (!e || e === document.body) return null;
	let n = window.getComputedStyle(e), r = t === "vertical" ? n.overflowY : n.overflowX;
	return (r === "auto" || r === "scroll") && (t === "vertical" ? e.scrollHeight > e.clientHeight : e.scrollWidth > e.clientWidth) ? e : He(e.parentElement, t);
}, Ue = (e, t, n, r) => {
	let i = Math.abs(t), a = Math.abs(n);
	if (r.hasVertical && n !== 0 && (!r.hasHorizontal || a >= i)) {
		let t = Math.max(0, e.scrollHeight - e.clientHeight), i = e.scrollTop <= 0, a = e.scrollTop >= t, o = n > 0, s = n < 0, c = o && i && r.allowDown, l = s && a && r.allowUp;
		return c || l;
	}
	if (r.hasHorizontal && t !== 0 && (!r.hasVertical || i > a)) {
		let n = Math.max(0, e.scrollWidth - e.clientWidth), i = e.scrollLeft <= 0, a = e.scrollLeft >= n, o = t > 0, s = t < 0, c = o && i && r.allowRight, l = s && a && r.allowLeft;
		return c || l;
	}
	return null;
}, We = (e) => {
	let { elementRef: t, directions: n, movementCssVars: r, swipeThreshold: i, canStart: o, onDismiss: s, onProgress: c, onCancel: l, onSwipeStart: u, onRelease: d, onSwipingChange: f } = e, p = a(() => E(n).includes("up") || E(n).includes("down")), m = a(() => E(n).includes("left") || E(n).includes("right")), h = a(() => E(n).includes("up")), g = a(() => E(n).includes("down")), _ = a(() => E(n).includes("left")), ee = a(() => E(n).includes("right")), v = a(() => p.value === m.value ? null : p.value ? "vertical" : "horizontal"), y = C(!1), b = C(void 0), x = C({
		x: 0,
		y: 0
	}), S = {
		x: 0,
		y: 0
	}, w, T = 0, ne = !1, D = !1, O = !1, re = null, A = !1, j = null, M = null, N = !1, P = !1, F = {
		width: 0,
		height: 0
	}, ie = 0, I = null, ae = {
		x: 0,
		y: 0
	}, R = null, z = null, B = !1, V = (e, t) => typeof i == "function" ? Math.max(0, i({
		element: e,
		direction: t
	})) : typeof i == "number" ? i : Pe, oe = (e) => {
		y.value !== e && (y.value = e, f?.(e));
	}, se = (e, t) => {
		if (I && t > I.time) {
			let n = Math.max(t - I.time, ze);
			ae = {
				x: (e.x - I.x) / n,
				y: (e.y - I.y) / n
			};
		}
		I = {
			x: e.x,
			y: e.y,
			time: t
		};
	}, ce = (e, t, n) => {
		e.style.setProperty(r.x, `${t}px`), e.style.setProperty(r.y, `${n}px`);
	}, le = (e) => {
		e.style.setProperty(r.x, "0px"), e.style.setProperty(r.y, "0px");
	}, ue = () => {
		oe(!1), b.value = void 0, x.value = {
			x: 0,
			y: 0
		}, S = {
			x: 0,
			y: 0
		}, w = void 0, T = 0, ne = !1, D = !1, O = !1, re = null, F = {
			width: 0,
			height: 0
		}, ie = 0, I = null, ae = {
			x: 0,
			y: 0
		}, R = null;
	}, H = () => {
		ue(), A = !1, j = null, M = null, N = !1, P = !1, z = null, B = !1;
	}, U = (e, t) => {
		ue(), ye(e), S = t, re = t, F = {
			width: e.offsetWidth,
			height: e.offsetHeight
		}, D = !0, O = !0;
	}, de = (e, t) => {
		let n = (e) => e >= 0 ? e ** .5 : -(Math.abs(e) ** .5), r = (e, t, r) => !t && e < 0 || !r && e > 0 ? n(e) : e;
		return {
			x: m.value ? r(e, _.value, ee.value) : n(e),
			y: p.value ? r(t, h.value, g.value) : n(t)
		};
	}, fe = (e, t) => {
		if (P) return !0;
		if (N || !M || !v.value) return !1;
		if (!e.cancelable) return P = !0, !0;
		let n = v.value === "vertical", r = n ? t.y - S.y : t.x - S.x, i = n ? t.x - S.x : t.y - S.y, a = Math.abs(r), o = Math.abs(i);
		return o >= Le && o > a + Re ? (P = !0, !0) : a >= Le ? (N = !0, !1) : !0;
	}, W = (e, r, i) => {
		let a = r.x - S.x, o = r.y - S.y;
		if (D) {
			D = !1;
			let e = Math.abs(a), t = Math.abs(o);
			R = p.value && m.value ? e > t ? "horizontal" : "vertical" : p.value ? "vertical" : "horizontal";
		}
		let s = R === "vertical" ? 0 : a, l = R === "horizontal" ? 0 : o, d = E(n).find((e) => Y(e, s, l) > 0);
		if (O && re) {
			if (Math.max(Math.abs(s), Math.abs(l)) < Ie) return;
			O = !1, oe(!0), u?.();
		}
		if (!y.value) return;
		!w && d && (w = d, b.value = d, T = Y(d, s, l));
		let f = w;
		if (f && !ne) {
			let e = Y(f, s, l);
			T = Math.max(T, e), T > Pe / 2 && T - e > Fe && (ne = !0);
		}
		let h = de(s, l);
		x.value = {
			x: h.x,
			y: h.y
		}, ce(e, h.x, h.y), se({
			x: h.x,
			y: h.y
		}, i);
		let g = t.value, _ = f ?? E(n)[0];
		if (g && _) {
			let e = _ === "up" || _ === "down" ? F.height || g.offsetHeight : F.width || g.offsetWidth, t = V(g, _), n = Math.min(1, Math.max(0, Y(_, s, l) / (e + t)));
			n !== ie && (ie = n, c?.(n, {
				deltaX: h.x,
				deltaY: h.y,
				direction: f
			}));
		}
	}, G = (e) => {
		if (!y.value) {
			H();
			return;
		}
		let t = Y(w ?? E(n)[0], x.value.x, x.value.y), r = V(e, w ?? E(n)[0]), i = performance.now(), a = (I ? i - I.time : Infinity) > Be ? {
			x: 0,
			y: 0
		} : ae;
		if (d?.(a) !== !0) {
			let i = Y(w ?? E(n)[0], a.x, a.y);
			!ne && (t >= r || i > .3) ? (e.setAttribute("data-swipe-dismissed", ""), s?.()) : (le(e), l?.());
		}
		H();
	}, pe = (n) => {
		if (!E(e.enabled) || n.pointerType === "touch" || n.button !== 0 || o && !o() || n.target?.closest(Ve)) return;
		let r = t.value;
		if (r) {
			U(r, {
				x: n.clientX,
				y: n.clientY
			}), z = n.pointerId, B = !0;
			try {
				r.setPointerCapture(n.pointerId);
			} catch {}
		}
	}, me = (e) => {
		if (!B || e.pointerId !== z) return;
		let n = t.value;
		if (n) {
			if (!(e.buttons & 1)) {
				G(n);
				return;
			}
			W(n, {
				x: e.clientX,
				y: e.clientY
			}, e.timeStamp);
		}
	}, K = (e) => {
		if (!B || e.pointerId !== z) return;
		let n = t.value;
		if (!n) {
			H();
			return;
		}
		G(n);
	}, he = () => {
		if (!B) return;
		let e = t.value;
		if (!e) {
			H();
			return;
		}
		G(e);
	}, ge = (n) => {
		if (!E(e.enabled) || o && !o()) return;
		let r = n.target;
		if (r?.closest(Ve)) return;
		let i = t.value;
		if (!i) return;
		if (M = null, N = !1, P = !1, !e.ignoreScrollableAncestors) {
			let e = He(r, p.value ? "vertical" : "horizontal");
			e && (A = !0, j = e);
		}
		v.value && (M = He(r, v.value === "vertical" ? "horizontal" : "vertical"));
		let a = n.touches[0];
		a && U(i, {
			x: a.clientX,
			y: a.clientY
		});
	}, _e = (e) => {
		let n = t.value;
		if (!n || !O && !y.value) return;
		let r = e.touches[0];
		if (!r) return;
		let i = {
			x: r.clientX,
			y: r.clientY
		};
		if (fe(e, i)) return;
		if (A && O && j) {
			let e = i.x - S.x, t = i.y - S.y, n = Ue(j, e, t, {
				hasVertical: p.value,
				hasHorizontal: m.value,
				allowUp: h.value,
				allowDown: g.value,
				allowLeft: _.value,
				allowRight: ee.value
			});
			if (n === !1) {
				H();
				return;
			}
			n === !0 && (A = !1, j = null);
		}
		let a = y.value;
		W(n, i, e.timeStamp), (a || y.value) && e.preventDefault();
	}, q = () => {
		let e = t.value;
		e && G(e);
	}, J = [];
	return k(() => t.value, (e) => {
		if (J.forEach((e) => e()), J.length = 0, !e) return;
		let t = e.ownerDocument, n = t.defaultView;
		J.push(L(e, "pointerdown", pe), L(e, "pointermove", me), L(e, "pointerup", K), L(e, "pointercancel", K), L(e, "lostpointercapture", he), L(t, "pointerup", K), L(t, "pointercancel", K), L(e, "touchstart", ge, { passive: !0 }), L(e, "touchmove", _e, { passive: !1 }), L(e, "touchend", q), L(e, "touchcancel", q)), n && J.push(L(n, "blur", he));
	}, { immediate: !0 }), te(() => {
		J.forEach((e) => e()), J.length = 0, H();
	}), {
		isSwiping: y,
		swipeDirection: b,
		dragOffset: x
	};
}, [Z, Ge] = ((e, t) => {
	let n = typeof e == "string" && !t ? `${e}Context` : t, r = Symbol(n);
	return [(t) => {
		let n = m(r, t);
		if (n || n === null) return n;
		throw Error(`Injection \`${r.toString()}\` not found. Component must be used within ${Array.isArray(e) ? `one of the following components: ${e.join(", ")}` : `\`${e}\``}`);
	}, (e) => (x(r, e), e)];
})("DrawerRoot"), Ke = (e) => e ? e.flatMap((e) => e.type === t ? Ke(e.children) : [e]) : [], qe = l({
	name: "PrimitiveSlot",
	inheritAttrs: !1,
	setup(t, { attrs: n, slots: r }) {
		return () => {
			if (!r.default) return null;
			let t = Ke(r.default()), a = t.findIndex((t) => t.type !== e);
			if (a === -1) return t;
			let o = t[a];
			delete o.props?.ref;
			let s = o.props ? h(n, o.props) : n, c = i({
				...o,
				props: {}
			}, s);
			return t.length === 1 ? c : (t[a] = c, t);
		};
	}
}), Je = [
	"area",
	"img",
	"input"
], Q = l({
	name: "Primitive",
	inheritAttrs: !1,
	props: {
		asChild: {
			type: Boolean,
			default: !1
		},
		as: {
			type: [String, Object],
			default: "div"
		}
	},
	setup(e, { attrs: t, slots: n }) {
		let r = e.asChild ? "template" : e.as;
		return typeof r == "string" && Je.includes(r) ? () => p(r, t) : r === "template" ? () => p(qe, t, { default: n.default }) : () => p(e.as, t, { default: n.default });
	}
}), Ye = /* @__PURE__ */ l({
	__name: "DrawerClose",
	props: {
		asChild: { type: Boolean },
		as: { default: "button" }
	},
	setup(e) {
		let t = e;
		X();
		let n = Z();
		return (r, i) => (b(), o(O(Q), h(t, {
			type: e.as === "button" ? "button" : void 0,
			onClick: i[0] ||= (e) => O(n).onOpenChange(!1)
		}), {
			default: j(() => [w(r.$slots, "default")]),
			_: 3
		}, 16, ["type"]));
	}
}), Xe = /* @__PURE__ */ l({
	__name: "DismissableLayer",
	props: {
		asChild: { type: Boolean },
		as: {},
		disableOutsidePointerEvents: {
			type: Boolean,
			default: !1
		},
		present: {
			type: Boolean,
			default: !0
		}
	},
	emits: [
		"escapeKeyDown",
		"pointerDownOutside",
		"focusOutside",
		"interactOutside",
		"dismiss"
	],
	setup(e, { emit: t }) {
		let n = e, r = t, { forwardRef: i, currentElement: s } = X(), c = a(() => s.value?.ownerDocument ?? globalThis.document), l = a(() => V.layersRoot), u = a(() => s.value ? Array.from(l.value).indexOf(s.value) : -1), d = a(() => V.layersWithOutsidePointerEventsDisabled.size > 0), f = a(() => {
			let e = Array.from(l.value), [t] = [...V.layersWithOutsidePointerEventsDisabled].slice(-1), n = e.indexOf(t);
			return u.value >= n;
		}), p = async (e) => {
			r("pointerDownOutside", e), r("interactOutside", e), await g(), e.defaultPrevented || r("dismiss");
		}, m = Te((e) => {
			let t = [...V.branches].some((t) => t?.contains(e.target));
			!n.present || !f.value || t || p(e);
		}, s, () => n.present), h = Ee((e) => {
			let t = [...V.branches].some((t) => t?.contains(e.target));
			!n.present || t || (r("focusOutside", e), r("interactOutside", e), e.defaultPrevented || r("dismiss"));
		}, s);
		return F("Escape", (e) => {
			n.present && u.value === l.value.size - 1 && (r("escapeKeyDown", e), e.defaultPrevented || r("dismiss"));
		}), k([
			s,
			() => n.disableOutsidePointerEvents,
			() => n.present
		], ([e, t, n], r, i) => {
			!e || !n || t && (V.layersWithOutsidePointerEventsDisabled.size === 0 && (V.originalBodyPointerEvents = c.value.body.style.pointerEvents, c.value.body.style.pointerEvents = "none"), V.layersWithOutsidePointerEventsDisabled.add(e), i(() => {
				V.layersWithOutsidePointerEventsDisabled.delete(e), V.layersWithOutsidePointerEventsDisabled.size === 0 && !z(V.originalBodyPointerEvents) && (c.value.body.style.pointerEvents = V.originalBodyPointerEvents);
			}));
		}, { immediate: !0 }), k([s, () => n.present], ([e, t], n, r) => {
			!e || !t || (l.value.add(e), r(() => {
				l.value.delete(e);
			}));
		}, { immediate: !0 }), A((e) => {
			e(() => {
				s.value && (l.value.delete(s.value), V.layersWithOutsidePointerEventsDisabled.delete(s.value));
			});
		}), (t, n) => (b(), o(O(Q), {
			ref: O(i),
			as: e.as,
			"as-child": e.asChild,
			"data-dismissable-layer": "",
			style: ee({ pointerEvents: d.value ? f.value ? "auto" : "none" : void 0 }),
			onBlurCapture: O(h).onBlurCapture,
			onFocusCapture: O(h).onFocusCapture,
			onPointerdownCapture: O(m).onPointerDownCapture
		}, {
			default: j(() => [w(t.$slots, "default")]),
			_: 3
		}, 8, [
			"as",
			"as-child",
			"style",
			"onBlurCapture",
			"onFocusCapture",
			"onPointerdownCapture"
		]));
	}
}), $ = C([]), Ze = () => ({
	add(e) {
		let t = $.value[0];
		e !== t && t?.pause(), $.value = Qe($.value, e), $.value.unshift(e);
	},
	remove(e) {
		$.value = Qe($.value, e), $.value[0]?.resume();
	}
}), Qe = (e, t) => {
	let n = [...e], r = n.indexOf(t);
	return r !== -1 && n.splice(r, 1), n;
}, $e = /* @__PURE__ */ l({
	__name: "FocusScope",
	props: {
		asChild: { type: Boolean },
		as: {},
		loop: {
			type: Boolean,
			default: !1
		},
		trapped: {
			type: Boolean,
			default: !1
		},
		present: {
			type: Boolean,
			default: !0
		}
	},
	emits: ["mountAutoFocus", "unmountAutoFocus"],
	setup(e, { emit: t }) {
		let n = e, r = t, { currentRef: i, currentElement: a } = X(), s = C(null), c = Ze(), l = S({
			paused: !1,
			pause() {
				this.paused = !0;
			},
			resume() {
				this.paused = !1;
			}
		});
		A((e) => {
			if (!N) return;
			let t = a.value;
			if (!n.trapped) return;
			let r = (e) => {
				if (l.paused || !t) return;
				let n = e.target;
				t.contains(n) ? s.value = n : q(s.value, { select: !0 });
			}, i = (e) => {
				if (l.paused || !t) return;
				let n = e.relatedTarget;
				n !== null && (t.contains(n) || q(s.value, { select: !0 }));
			}, o = (e) => {
				let n = s.value;
				if (n === null || !e.some((e) => e.removedNodes.length > 0)) return;
				let r = U();
				r && t.contains(r) || t.contains(n) || q(t);
			};
			document.addEventListener("focusin", r), document.addEventListener("focusout", i);
			let c = new MutationObserver(o);
			t && c.observe(t, {
				childList: !0,
				subtree: !0
			}), e(() => {
				document.removeEventListener("focusin", r), document.removeEventListener("focusout", i), c.disconnect();
			});
		});
		let u = (e, t) => {
			let n = new CustomEvent(fe, G), i = (e) => r("mountAutoFocus", e);
			e.addEventListener(fe, i), e.dispatchEvent(n), e.removeEventListener(fe, i), n.defaultPrevented || (pe(K(e), { select: !0 }), U() === t && q(e));
		}, d = async (e) => {
			let t = a.value;
			if (await g(), !t) return;
			n.present !== !1 && c.add(l);
			let i = U();
			!t.contains(i) && n.present !== !1 && u(t, i), e(() => {
				let e = new CustomEvent(W, G), n = (e) => {
					r("unmountAutoFocus", e);
				};
				t.addEventListener(W, n), t.dispatchEvent(e), t.setAttribute("data-focus-scope-unmounting", ""), setTimeout(() => {
					e.defaultPrevented || q(i ?? document.body, { select: !0 }), t.removeEventListener(W, n), c.remove(l), t.removeAttribute("data-focus-scope-unmounting");
				}, 0);
			});
		};
		A((e) => void d(e)), k(() => n.present, async (e, t) => {
			if (!N) return;
			if (e === !1 && t === !0) {
				c.remove(l);
				return;
			}
			if (e !== !0 || t !== !1) return;
			c.add(l), await g();
			let n = a.value;
			if (!n) return;
			let r = U();
			n.contains(r) || u(n, r);
		});
		let f = (e) => {
			if (!n.loop && !n.trapped || l.paused) return;
			let t = e.key === "Tab" && !e.altKey && !e.ctrlKey && !e.metaKey, r = U();
			if (t && r) {
				let t = e.currentTarget, [i, a] = me(t);
				i && a ? !e.shiftKey && r === a ? (e.preventDefault(), n.loop && q(i, { select: !0 })) : e.shiftKey && r === i && (e.preventDefault(), n.loop && q(a, { select: !0 })) : r === t && e.preventDefault();
			}
		};
		return (t, n) => (b(), o(O(Q), {
			ref_key: "currentRef",
			ref: i,
			as: e.as,
			"as-child": e.asChild,
			tabindex: "-1",
			onKeydown: f
		}, {
			default: j(() => [w(t.$slots, "default")]),
			_: 3
		}, 8, ["as", "as-child"]));
	}
}), et = /* @__PURE__ */ l({
	__name: "DrawerContentImpl",
	props: {
		asChild: { type: Boolean },
		as: {},
		disableOutsidePointerEvents: { type: Boolean },
		trapFocus: { type: Boolean }
	},
	emits: [
		"escapeKeyDown",
		"pointerDownOutside",
		"focusOutside",
		"interactOutside",
		"openAutoFocus",
		"closeAutoFocus"
	],
	setup(e, { emit: t }) {
		let n = e, r = t, i = Z(), { forwardRef: s, currentElement: l } = X();
		xe();
		let { isSwiping: u } = We({
			enabled: a(() => i.open.value),
			elementRef: l,
			directions: ["down"],
			movementCssVars: {
				x: J.swipeMovementX,
				y: J.swipeMovementY
			},
			onDismiss() {
				i.onOpenChange(!1);
			},
			onSwipingChange(e) {
				i.onSwipingChange(e);
			}
		}), d = () => {
			u.value || i.onOpenChange(!1);
		}, f = (e) => {
			if (u.value) {
				e.preventDefault();
				return;
			}
			r("pointerDownOutside", e);
		}, p = (e) => {
			if (u.value) {
				e.preventDefault();
				return;
			}
			r("focusOutside", e);
		}, m = (e) => {
			if (u.value) {
				e.preventDefault();
				return;
			}
			r("interactOutside", e);
		}, g = a(() => {
			let e = {
				"data-drawer-content": "",
				"data-state": i.open.value ? "open" : "closed"
			};
			return u.value && (e["data-swiping"] = ""), e;
		});
		return process.env.NODE_ENV !== "production" && v(() => {
			document.getElementById(i.titleId) || console.warn("Warning: `DrawerContent` requires a `DrawerTitle` for accessibility.");
		}), (t, a) => (b(), o($e, {
			"as-child": "",
			loop: "",
			trapped: n.trapFocus,
			onMountAutoFocus: a[1] ||= (e) => r("openAutoFocus", e),
			onUnmountAutoFocus: a[2] ||= (e) => r("closeAutoFocus", e)
		}, {
			default: j(() => [c(Xe, h({
				id: O(i).contentId,
				ref: O(s),
				"aria-describedby": O(i).descriptionId,
				"aria-labelledby": O(i).titleId,
				as: e.as,
				"as-child": e.asChild,
				"disable-outside-pointer-events": e.disableOutsidePointerEvents,
				role: "dialog"
			}, {
				...g.value,
				...t.$attrs
			}, {
				onDismiss: d,
				onEscapeKeyDown: a[0] ||= (e) => r("escapeKeyDown", e),
				onFocusOutside: p,
				onInteractOutside: m,
				onPointerDownOutside: f
			}), {
				default: j(() => [w(t.$slots, "default")]),
				_: 3
			}, 16, [
				"id",
				"aria-describedby",
				"aria-labelledby",
				"as",
				"as-child",
				"disable-outside-pointer-events"
			])]),
			_: 3
		}, 8, ["trapped"]));
	}
}), tt = l({
	name: "Presence",
	props: {
		present: {
			type: Boolean,
			required: !0
		},
		forceMount: { type: Boolean }
	},
	slots: Object,
	setup(e, { slots: t, expose: n }) {
		let { present: r, forceMount: i } = ne(e), a = C(), { isPresent: o } = Me(r, a);
		n({ present: o });
		let s = t.default({ present: o.value });
		s = Ke(s || []);
		let c = d();
		if (s && s?.length > 1) {
			let e = c?.parent?.type.name ? `<${c.parent.type.name} />` : "component";
			throw Error([
				`Detected an invalid children for \`${e}\` for  \`Presence\` component.`,
				"",
				"Note: Presence works similarly to `v-if` directly, but it waits for animation/transition to finished before unmounting. So it expect only one direct child of valid VNode type.",
				"You can apply a few solutions:",
				["Provide a single child element so that `presence` directive attach correctly.", "Ensure the first child is an actual element instead of a raw text node or comment node."].map((e) => `  - ${e}`).join("\n")
			].join("\n"));
		}
		return () => i.value || r.value || o.value ? p(t.default({ present: o.value })[0], { ref: (e) => {
			let t = I(e);
			return t?.hasAttribute === void 0 || (t?.hasAttribute("data-popper-content-wrapper") ? a.value = t.firstElementChild : a.value = t), t;
		} }) : null;
	}
}), nt = /* @__PURE__ */ l({
	__name: "DrawerContent",
	props: {
		asChild: { type: Boolean },
		as: {},
		disableOutsidePointerEvents: { type: Boolean }
	},
	emits: [
		"escapeKeyDown",
		"pointerDownOutside",
		"focusOutside",
		"interactOutside",
		"openAutoFocus",
		"closeAutoFocus"
	],
	setup(e, { emit: t }) {
		let n = e, r = t, i = Z(), a = De(r), { forwardRef: s, currentElement: l } = X();
		Oe(l);
		let u = (e) => {
			let t = e.detail.originalEvent;
			(t.button === 2 || t.button === 0 && t.ctrlKey) && e.preventDefault();
		};
		return (e, t) => (b(), o(O(tt), { present: O(i).open.value }, {
			default: j(() => [c(et, h({ ref: O(s) }, {
				...n,
				...O(a),
				...e.$attrs
			}, {
				"disable-outside-pointer-events": !0,
				"trap-focus": O(i).open.value,
				onCloseAutoFocus: t[0] ||= (e) => e.preventDefault(),
				onFocusOutside: t[1] ||= (e) => e.preventDefault(),
				onPointerDownOutside: u
			}), {
				default: j(() => [w(e.$slots, "default")]),
				_: 3
			}, 16, ["trap-focus"])]),
			_: 3
		}, 8, ["present"]));
	}
}), rt = /* @__PURE__ */ l({
	__name: "DrawerDescription",
	props: {
		asChild: { type: Boolean },
		as: { default: "p" }
	},
	setup(e) {
		let t = e;
		X();
		let n = Z();
		return (e, r) => (b(), o(O(Q), h(t, { id: O(n).descriptionId }), {
			default: j(() => [w(e.$slots, "default")]),
			_: 3
		}, 16, ["id"]));
	}
}), it = /* @__PURE__ */ l({
	__name: "DrawerHandle",
	props: {
		asChild: { type: Boolean },
		as: { default: "div" }
	},
	setup(e) {
		let t = e;
		X();
		let n = Z();
		return (e, r) => (b(), o(O(Q), h(t, {
			"aria-hidden": "true",
			"data-state": O(n).open.value ? "open" : "closed"
		}), {
			default: j(() => [w(e.$slots, "default")]),
			_: 3
		}, 16, ["data-state"]));
	}
}), at = /* @__PURE__ */ l({
	__name: "DrawerOverlayImpl",
	props: {
		asChild: { type: Boolean },
		as: {}
	},
	setup(e) {
		let t = Z(), n = le(t.open.value);
		k(() => t.open.value, (e) => {
			n.value = e;
		}, { immediate: !0 }), X();
		let r = a(() => {
			let e = {
				"data-drawer-overlay": "",
				"data-state": t.open.value ? "open" : "closed"
			};
			return t.isSwiping.value && (e["data-swiping"] = ""), e;
		});
		return (t, n) => (b(), o(O(Q), h({
			as: e.as,
			"as-child": e.asChild
		}, r.value, { style: {
			pointerEvents: "auto",
			userSelect: "none"
		} }), {
			default: j(() => [w(t.$slots, "default")]),
			_: 3
		}, 16, ["as", "as-child"]));
	}
}), ot = /* @__PURE__ */ l({
	__name: "DrawerOverlay",
	props: {
		asChild: { type: Boolean },
		as: {}
	},
	setup(e) {
		let t = Z(), { forwardRef: n } = X();
		return (r, i) => (b(), o(O(tt), { present: O(t).open.value }, {
			default: j(() => [c(at, h(r.$attrs, {
				ref: O(n),
				as: e.as,
				"as-child": e.asChild
			}), {
				default: j(() => [w(r.$slots, "default")]),
				_: 3
			}, 16, ["as", "as-child"])]),
			_: 3
		}, 8, ["present"]));
	}
}), st = /* @__PURE__ */ l({
	__name: "Teleport",
	props: {
		to: {},
		disabled: { type: Boolean },
		defer: { type: Boolean },
		forceMount: { type: Boolean }
	},
	setup(e) {
		let t = e, r = a(() => t.to ?? "body"), i = ae();
		return (t, a) => O(i) || e.forceMount ? (b(), o(n, {
			key: 0,
			defer: e.defer,
			disabled: e.disabled,
			to: r.value
		}, [w(t.$slots, "default")], 8, [
			"defer",
			"disabled",
			"to"
		])) : s("", !0);
	}
}), ct = /* @__PURE__ */ l({
	__name: "DrawerPortal",
	props: {
		to: {},
		disabled: { type: Boolean },
		defer: { type: Boolean },
		forceMount: { type: Boolean }
	},
	setup(e) {
		return (e, t) => (b(), o(st, _(f(e.$props)), {
			default: j(() => [w(e.$slots, "default")]),
			_: 3
		}, 16));
	}
}), lt = /* @__PURE__ */ l({
	__name: "DrawerRoot",
	props: {
		open: {
			type: Boolean,
			default: void 0
		},
		defaultOpen: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["update:open"],
	setup(e, { emit: t }) {
		let n = e, r = t, i = C(n.defaultOpen), o = a(() => n.open ?? i.value), s = C(!1);
		return Ge({
			open: o,
			isSwiping: s,
			onOpenChange: (e) => {
				o.value !== e && (i.value = e, r("update:open", e));
			},
			onSwipingChange(e) {
				s.value = e;
			},
			contentId: Ae(void 0, "drawer-content"),
			titleId: Ae(void 0, "drawer-title"),
			descriptionId: Ae(void 0, "drawer-description")
		}), (e, t) => w(e.$slots, "default");
	}
}), ut = /* @__PURE__ */ l({
	__name: "DrawerTitle",
	props: {
		asChild: { type: Boolean },
		as: { default: "h2" }
	},
	setup(e) {
		let t = e, n = Z();
		return X(), (e, r) => (b(), o(O(Q), h(t, { id: O(n).titleId }), {
			default: j(() => [w(e.$slots, "default")]),
			_: 3
		}, 16, ["id"]));
	}
});
//#endregion
export { Ye as DrawerClose, nt as DrawerContent, rt as DrawerDescription, it as DrawerHandle, ot as DrawerOverlay, ct as DrawerPortal, lt as DrawerRoot, ut as DrawerTitle };
